export const VIOLATION_TOOLTIP_TEXT =
  'Violation: lineup order should follow roster slot (mains first, subs last). Examples: a stronger (lower slot) player placed below a weaker one, or a sub (slot 4-6) placed above a main (slot 1-3).';
